import { useEffect } from 'react'

export function useAddHtmlClass(className: string) {
  useEffect(() => {
    const htmlElement = document.documentElement

    htmlElement.classList.add(className)

    return () => {
      htmlElement.classList.remove(className)
    }
  }, [])
}
